import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { RidePrefilledAddresses } from '@/models/ride';

export const fetchPrefilledRideAddresses = async (operatorId: string): Promise<RidePrefilledAddresses> => {
  const response = await queryExecute({
    query: graphql(`
      query getPrefilledRideAddresses($operatorId: String!) {
        getPrefilledRideAddresses(operatorId: $operatorId) {
          pickup {
            placeId
            name
            streetAddress
            city
            state
            zip
            latitude
            longitude
          }
          destination {
            placeId
            name
            streetAddress
            city
            state
            zip
            latitude
            longitude
          }
          pickupDateTime
        }
      }
    `),
    variables: {
      operatorId,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.getPrefilledRideAddresses!;
};
